/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntegrationOptionGroupQueryResponse } from './IntegrationOptionGroupQueryResponse';
import {
    IntegrationOptionGroupQueryResponseFromJSON,
    IntegrationOptionGroupQueryResponseFromJSONTyped,
    IntegrationOptionGroupQueryResponseToJSON,
} from './IntegrationOptionGroupQueryResponse';
import type { ListMeta } from './ListMeta';
import {
    ListMetaFromJSON,
    ListMetaFromJSONTyped,
    ListMetaToJSON,
} from './ListMeta';

/**
 * 
 * @export
 * @interface ListIntegrationOptionQueryResponse
 */
export interface ListIntegrationOptionQueryResponse {
    /**
     * 
     * @type {ListMeta}
     * @memberof ListIntegrationOptionQueryResponse
     */
    meta: ListMeta;
    /**
     * 
     * @type {Array<IntegrationOptionGroupQueryResponse>}
     * @memberof ListIntegrationOptionQueryResponse
     */
    data: Array<IntegrationOptionGroupQueryResponse>;
}

/**
 * Check if a given object implements the ListIntegrationOptionQueryResponse interface.
 */
export function instanceOfListIntegrationOptionQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ListIntegrationOptionQueryResponseFromJSON(json: any): ListIntegrationOptionQueryResponse {
    return ListIntegrationOptionQueryResponseFromJSONTyped(json, false);
}

export function ListIntegrationOptionQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListIntegrationOptionQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': ListMetaFromJSON(json['meta']),
        'data': ((json['data'] as Array<any>).map(IntegrationOptionGroupQueryResponseFromJSON)),
    };
}

export function ListIntegrationOptionQueryResponseToJSON(value?: ListIntegrationOptionQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': ListMetaToJSON(value.meta),
        'data': ((value.data as Array<any>).map(IntegrationOptionGroupQueryResponseToJSON)),
    };
}

